import React, { useEffect, useState } from "react";
import { useMessage } from "../../Components/MessageProvider/MessageProvider";

import axiosInstance from "../../Components/axiosInstance/AxiosInstance";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "antd";
import YukXatiList from "../../Components/YukXati/YukXatiList";
import YukXatiHeader from "../../Components/YukXati/YukXatiHeader";
import { AiOutlineDelete } from "react-icons/ai";
import { LiaEdit } from "react-icons/lia";

export default function YukxatiGlobal() {
  let navigate = useNavigate();
  const messageApi = useMessage();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  let [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);

  let getSolds = async () => {
    if (loading || page >= data?.total) return;
    try {
      setLoading(true);

      let { data: info } = await axiosInstance.get(
        `/api/chiqim?offset=${page > 0 ? page - 50 : page}&limit=${
          page == 0 ? page + 50 : page
        }`
      );
      console.log("data");
      console.log(data);
      setData({ ...info, data: [...info?.data] });
      setPage((prevPage) => prevPage + 50);
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSolds();
  }, []);

  // Scroll handler
  const handleScroll = () => {
    // Check if user has scrolled to bottom
    if (
      window.innerHeight + window.scrollY >=
        document.documentElement.scrollHeight - 500 &&
      !loading
    ) {
      getSolds();
    }
  };

  // Add scroll listener
  useEffect(() => {
    console.log("Removing scroll listener");
    window.addEventListener("scroll", handleScroll);
    return () => {
      console.log("Removing scroll listener");
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  if (data?.data?.length == 0 || !data) {
    return (
      <div>
        <YukXatiHeader PageTitle={"YukXati"} />
        <main class="grid  place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
          <div class="text-center">
            {/* <p class="text-base font-semibold text-indigo-600">404</p>
            <h1 class="mt-4 text-balance text-5xl font-semibold tracking-tight text-gray-900 sm:text-7xl">
              Page not found
            </h1> */}
            <p class="mt-6 text-pretty text-lg font-medium text-gray-500 sm:text-xl/8">
              Yukxati mavjud emas
            </p>
            <div class="mt-10 flex items-center justify-center gap-x-6">
              <Link
                to="/yukxati/cutomer"
                class="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Yukxati qo'shish
              </Link>
              <Link to="/yukxati" class="text-sm font-semibold text-gray-900">
                Asosiy sahifa <span aria-hidden="true">&rarr;</span>
              </Link>
            </div>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div>
      <YukXatiHeader PageTitle={"YukXati"} />

      {selected.length > 0 ? (
        <div className="fixed top-0 left-0 w-[100%] bg-[#fff] h-[45px]  ">
          <div className="max-w-[900px] w-[100%] h-[100%] m-auto flex flex-row items-center justify-end border-b-[1px] gap-2 border-[#bfbfbf] shadow-sm">
            {selected.length === 1 ? (
              <Button icon={<AiOutlineDelete />} />
            ) : null}
            {selected.length === 1 ? (
              <Link
                to={
                  "/yukxati/edit/" +
                  selected[0]?.customer_id +
                  "?" +
                  selected[0]?.id
                }
              >
                <Button onClick={() => {}} icon={<LiaEdit />} />
              </Link>
            ) : null}
          </div>
        </div>
      ) : null}
      <div className="pb-[70px]">
        <YukXatiList
          data={data?.data}
          setData={setData}
          setSelected={setSelected}
          selected={selected}
        />

        {loading ? (
          <div className="text-center pt-[20px]">
            <h2 className="text-[#bfbfbf]">Yukxatlari yuklanmoqda...</h2>
          </div>
        ) : (
          <div className="text-center pt-[20px]">
            <h2 className="text-[#bfbfbf]">No more...</h2>
          </div>
        )}
      </div>
    </div>
  );
}
